import { c as _c } from "react/compiler-runtime";
import React from "react";
import { AlertCircle } from "react-feather";
import { toast } from "react-toastify";
import { useMainLocale } from "../../context/MainLocaleContext";
const getFailureMessage = (locale: ReturnType<typeof useMainLocale>): string => locale === "dk" ? "Noget gik galt" : locale === "sv" ? "Något gick fel" : "Noe gikk galt";
export const useFailureToast = () => {
  const $ = _c(2);
  const locale = useMainLocale();
  let t0;
  if ($[0] !== locale) {
    t0 = message => toast.error(message ?? getFailureMessage(locale), {
      icon: <AlertCircle size={24} color="black" />
    });
    $[0] = locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const useFailureMessage = () => {
  const $ = _c(2);
  const locale = useMainLocale();
  let t0;
  if ($[0] !== locale) {
    t0 = getFailureMessage(locale);
    $[0] = locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};